<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            Recon Files
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-billing-filter (searchEvent)="onSearch($event)" [filterFields]="fields"></ppl-billing-filter>
                </div>
                <div class="table-style">
                    @if(reconFiles.length > 0) {
                    <ppl-list-table [customDataLoaded]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [cols]="cols" [enableActions]="false" [data]="reconFiles" (rowDetailEvent)="rowClicked($event)"
                        [disableSelection]="true" [gridTitle]="false" [pagination]="true" [loadPage]="true"
                        (onPageLoad)="onPageLoad($event)" [from]="'billing'">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>